module.exports = __webpack_public_path__ + "img/phone.ec2374fe.png";